import ThumbnailComponent from './component'
import ThumbnailContainer from './container'

export default ThumbnailComponent
export {
    ThumbnailComponent,
    ThumbnailContainer
}